import {
  IStripePriceRecurring,
  StripePriceRecurring,
} from './stripe-price-recuring.model';
import { IStripeProduct, StripeProduct } from './stripe-produt.model';

export interface IStripePriceProduct {
  id: string;
  object: string;
  active: boolean;
  billingScheme: 'per_unit' | 'tiered';
  created: number;
  currency: string;
  customUnitAmount: any | null;
  livemode: boolean;
  lookupKey: string | null;
  metadata: Record<string, any>;
  nickname: string | null;
  product: IStripeProduct;
  recurring: IStripePriceRecurring | null;
  taxBehavior: 'inclusive' | 'exclusive' | 'unspecified';
  tiersMode: string | null;
  transformQuantity: any | null;
  type: 'one_time' | 'recurring';
  unitAmount: number;
  unitAmountDecimal: string;
}

export class StripePriceProduct implements IStripePriceProduct {
  id: string;
  object: string;
  active: boolean;
  billingScheme: 'per_unit' | 'tiered';
  created: number;
  currency: string;
  customUnitAmount: any | null;
  livemode: boolean;
  lookupKey: string | null;
  metadata: Record<string, any>;
  nickname: string | null;
  product: IStripeProduct;
  recurring: IStripePriceRecurring | null;
  taxBehavior: 'inclusive' | 'exclusive' | 'unspecified';
  tiersMode: string | null;
  transformQuantity: any | null;
  type: 'one_time' | 'recurring';
  unitAmount: number;
  unitAmountDecimal: string;

  constructor(data: any) {
    this.id = data.id;
    this.object = data.object;
    this.active = data.active;
    this.billingScheme = data.billing_scheme;
    this.created = data.created;
    this.currency = data.currency;
    this.customUnitAmount = data.custom_unit_amount;
    this.livemode = data.livemode;
    this.lookupKey = data.lookup_key;
    this.metadata = data.metadata || {};
    this.nickname = data.nickname;
    this.product = new StripeProduct(data.product);
    this.recurring = data.recurring
      ? new StripePriceRecurring(data.recurring)
      : null;
    this.taxBehavior = data.tax_behavior;
    this.tiersMode = data.tiers_mode;
    this.transformQuantity = data.transform_quantity;
    this.type = data.type;
    this.unitAmount = data.unit_amount;
    this.unitAmountDecimal = data.unit_amount_decimal;
  }
}
